import { markdownBlueprint } from "@made-people/blueprint-markdown/blueprint";

markdownBlueprint.override({
  slots: {
    base: "text-body-sm md:text-body-md leading-normal max-w-screen-md",

    // Markdown Slots
    ul: "list-disc bg-surface-1 p-6 rounded-lg flex flex-col my-6",
    ol: "bg-surface-1 p-6 rounded-lg flex flex-col list-[auto] my-6",
    li: "[li>*]:ml-2 ml-6 my-2",
    span: "",
    p: "mb-2 last:mb-0",
    // alla h-taggar ska ja unika storlekar
    h1: "mt-[1.5em] first:mt-0 mb-[0.75em] text-body-sm md:text-body-md",
    h2: "mt-[1.5em] first:mt-0 mb-[0.75em] text-body-sm md:text-body-md",
    h3: "mt-[1.5em] first:mt-0 mb-[0.75em] text-body-sm md:text-body-md",
    h4: "mt-[1.5em] first:mt-0 mb-[0.75em] text-body-sm md:text-body-md",
    h5: "mt-[1.5em] first:mt-0 mb-[0.75em] text-body-sm md:text-body-md",
    h6: "mt-[1.5em] first:mt-0 mb-[0.75em] text-body-sm md:text-body-md",
    blockquote: "",
    hr: "",
    a: "underline decoration-secondary underline-offset-4",
    strong: "",
    em: "",
    code: "",
    img: "w-full aspect-[16/10] rounded-lg object-cover my-5",
    tr: "even:bg-surface-1",
    table: "w-full my-6 block overflow-x-auto",
    thead: "font-bold bg-surface-1",
    tbody: "gap-4",
    th: "!text-left text-heading-2xs font-bold py-3 px-3 bg-surface-2",
    td: "py-3 px-3 !text-left min-w-[150px]",
    pre: "",
  },
});
